<div class="alert-container d-flex py-kh-2 px-kh-4 h-100" [ngClass]="getClass()" [khA11yAlert]="type === alertTypeEnum.Danger ? 'alert' : 'status'" [khA11yAlertTrapFocus]="showCloseButton">

	<div class="close-alert-icon" *ngIf="showCloseButton" (click)="closeAlert()" khA11yClickable [khA11yLabel]="'A11Y_ALERT.DISMISS' | translate">
			<fa-icon [icon]="['fas','times']"></fa-icon>
	</div>

  <fa-icon *ngIf="type === alertTypeEnum.Danger" [icon]="['fas', 'exclamation-circle']" class="kh-red mr-kh-3"></fa-icon>
  <fa-icon *ngIf="type === alertTypeEnum.Warning" [icon]="['fas', 'exclamation-triangle']" class="kh-orange mr-kh-3"></fa-icon>
  <fa-icon *ngIf="type === alertTypeEnum.Info" [icon]="['fas', 'exclamation-circle']" class="d-flex align-items-end kh-blue-main mr-kh-2 py-kh-1"></fa-icon>

  <div class="d-flex flex-column justify-content-center">
    <div class="medium-text">{{title}}</div>
    <ng-content></ng-content>
  </div>

</div>
